"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHReference = void 0;
const KHEventHandler_1 = require("../KHEventHandler");
class KHReference extends KHEventHandler_1.KHEventHandler {
    constructor(value) {
        super([KHReference.EVENT_VALUE_CHANGED]);
        this.value = value;
    }
    set(value) {
        const changed = this.value !== value;
        this.value = value;
        if (changed) {
            this.emitEvent(KHReference.EVENT_VALUE_CHANGED, { value: this.value });
        }
    }
    get() {
        return this.value;
    }
}
exports.KHReference = KHReference;
KHReference.EVENT_VALUE_CHANGED = "vc";
